import type { ReactNode } from 'react';

import Brand from '../Brand';
import LanguageSwitcher from '../LanguageSwitcher';

interface MinimalHeaderDesktopProps {
  rightContent?: ReactNode;
  showLanguageSwitcher?: boolean;
}

const MinimalHeaderDesktop = ({
  rightContent,
  showLanguageSwitcher = true,
}: MinimalHeaderDesktopProps) => {
  return (
    <header className="w-full bg-surface-card px-20 py-5">
      <div className="mx-auto flex max-w-[1440px] items-center justify-between">
        <Brand link="/" variant="dark" showText={true} />
        <div className="flex items-center gap-8">
          {rightContent}
          {showLanguageSwitcher && <LanguageSwitcher variant="dark" />}
        </div>
      </div>
    </header>
  );
};

export default MinimalHeaderDesktop;
